/*
  CUSTOM MXM – Custom Header JS
  Projekt: Maximum Baits

  Steuert:
  - Shop Mega Drawer
  - Kategorie Hover Panels auf Desktop
  - Ranges Submenu
  - Mobile: keine Produktpanel-Interaktion
  - Mobile: normale Kategorie-Links navigieren direkt
  - Mobile: Ranges-Trigger klappt Submenu per Tap auf
*/

(() => {
  const initCustomMxmHeaders = () => {
    const headers = document.querySelectorAll('[data-custom-mxm-header]:not([data-custom-mxm-initialized])');

    headers.forEach((header) => {
      header.setAttribute('data-custom-mxm-initialized', 'true');

      const trigger = header.querySelector('[data-custom-mxm-mega-trigger]');
      const mega = header.querySelector('[data-custom-mxm-mega]');
      const categoryTriggers = header.querySelectorAll('[data-custom-mxm-category-trigger]');
      const panels = header.querySelectorAll('[data-custom-mxm-product-panel]');
      const groupWrappers = header.querySelectorAll('[data-custom-mxm-group]');

      if (!trigger || !mega) return;

      let closeTimer = null;
      let lastTouchToggleTime = 0;

      const isMobileNavigation = () => {
        return window.matchMedia('(max-width: 989px), (hover: none) and (pointer: coarse)').matches;
      };

      const clearActivePanels = () => {
        categoryTriggers.forEach((item) => {
          item.classList.remove('is-active');
        });

        panels.forEach((panel) => {
          panel.classList.remove('is-active');
        });
      };

      const closeAllGroups = () => {
        groupWrappers.forEach((wrapper) => {
          const button = wrapper.querySelector('[data-custom-mxm-group-trigger]');
          const panel = wrapper.querySelector('[data-custom-mxm-group-panel]');

          if (!button || !panel) return;

          button.classList.remove('is-open');
          button.setAttribute('aria-expanded', 'false');
          panel.classList.remove('is-open');
        });
      };

      const openMega = () => {
        window.clearTimeout(closeTimer);
        header.classList.add('is-mega-open');
        trigger.setAttribute('aria-expanded', 'true');
      };

      const forceCloseMega = () => {
        header.classList.remove('is-mega-open');
        trigger.setAttribute('aria-expanded', 'false');
        clearActivePanels();
        closeAllGroups();
      };

      const closeMega = () => {
        if (isMobileNavigation()) return;

        closeTimer = window.setTimeout(() => {
          forceCloseMega();
        }, 120);
      };

      const activatePanel = (id) => {
        if (!id || isMobileNavigation()) return;

        categoryTriggers.forEach((item) => {
          item.classList.toggle('is-active', item.dataset.customMxmCategoryTrigger === id);
        });

        panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.customMxmProductPanel === id);
        });
      };

      const openGroup = (wrapper) => {
        const button = wrapper.querySelector('[data-custom-mxm-group-trigger]');
        const panel = wrapper.querySelector('[data-custom-mxm-group-panel]');

        if (!button || !panel) return;

        button.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        panel.classList.add('is-open');
      };

      const closeGroup = (wrapper) => {
        const button = wrapper.querySelector('[data-custom-mxm-group-trigger]');
        const panel = wrapper.querySelector('[data-custom-mxm-group-panel]');

        if (!button || !panel) return;

        button.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        panel.classList.remove('is-open');
      };

      const toggleGroup = (button) => {
        const wrapper = button.closest('[data-custom-mxm-group]');

        if (!wrapper) return;

        openMega();
        clearActivePanels();

        if (button.classList.contains('is-open')) {
          closeGroup(wrapper);
        } else {
          openGroup(wrapper);
        }
      };

      const handleMegaTriggerClick = (event) => {
        event.preventDefault();

        if (header.classList.contains('is-mega-open')) {
          forceCloseMega();
        } else {
          openMega();
          clearActivePanels();
          closeAllGroups();
        }
      };

      const handleGroupTriggerInteraction = (event) => {
        const button = event.target.closest('[data-custom-mxm-group-trigger]');

        if (!button || !mega.contains(button)) return;

        event.preventDefault();
        event.stopPropagation();

        if (event.type === 'touchend') {
          lastTouchToggleTime = Date.now();
        }

        if (event.type === 'click' && Date.now() - lastTouchToggleTime < 500) {
          return;
        }

        toggleGroup(button);
      };

      trigger.addEventListener('mouseenter', () => {
        if (isMobileNavigation()) return;

        openMega();
        clearActivePanels();
        closeAllGroups();
      });

      trigger.addEventListener('focus', () => {
        openMega();
        clearActivePanels();
        closeAllGroups();
      });

      trigger.addEventListener('click', handleMegaTriggerClick);

      header.addEventListener('mouseenter', () => {
        if (isMobileNavigation()) return;
        window.clearTimeout(closeTimer);
      });

      header.addEventListener('mouseleave', closeMega);

      mega.addEventListener('mouseenter', () => {
        if (isMobileNavigation()) return;
        openMega();
      });

      mega.addEventListener('mouseleave', closeMega);

      mega.addEventListener('click', handleGroupTriggerInteraction);
      mega.addEventListener('touchend', handleGroupTriggerInteraction, { passive: false });

      categoryTriggers.forEach((item) => {
        const id = item.dataset.customMxmCategoryTrigger;

        item.addEventListener('mouseenter', () => {
          if (isMobileNavigation()) return;
          if (item.hasAttribute('data-custom-mxm-group-trigger')) return;

          openMega();
          activatePanel(id);
        });

        item.addEventListener('focus', () => {
          if (item.hasAttribute('data-custom-mxm-group-trigger')) return;

          openMega();

          if (!isMobileNavigation()) {
            activatePanel(id);
          }
        });

        item.addEventListener('touchstart', () => {
          /*
            Auf Mobile bewusst NICHT activatePanel(id) ausführen.
            Normale Kategorie-Links sollen beim ersten Tap direkt navigieren.
            Nur Ranges wird separat über den Group-Trigger getoggelt.
          */
        }, { passive: true });
      });

      groupWrappers.forEach((wrapper) => {
        wrapper.addEventListener('mouseenter', () => {
          if (isMobileNavigation()) return;

          openMega();
          openGroup(wrapper);
        });

        wrapper.addEventListener('mouseleave', () => {
          if (isMobileNavigation()) return;

          const activeRange = wrapper.querySelector('[data-custom-mxm-category-trigger].is-active');

          closeGroup(wrapper);

          if (activeRange) {
            clearActivePanels();
          }
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          forceCloseMega();
        }
      });

      window.addEventListener('resize', () => {
        if (isMobileNavigation()) {
          clearActivePanels();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomMxmHeaders);
  } else {
    initCustomMxmHeaders();
  }

  document.addEventListener('shopify:section:load', initCustomMxmHeaders);
})();